export default "__VITE_ASSET__DBVW99yV__"